/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Alt_SubtitleInputs */

const en_pc_alt_subtitle = /** @type {(inputs: Pc_Alt_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`When PdfCraft is enough, when it isn't, and what to use instead.`)
};

const zh_pc_alt_subtitle = /** @type {(inputs: Pc_Alt_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`什么时候 PdfCraft 就够用，什么时候不够，以及该换用什么。`)
};

/**
* | output |
* | --- |
* | "When PdfCraft is enough, when it isn't, and what to use instead." |
*
* @param {Pc_Alt_SubtitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_alt_subtitle = /** @type {((inputs?: Pc_Alt_SubtitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Alt_SubtitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_alt_subtitle(inputs)
	return zh_pc_alt_subtitle(inputs)
});
export { pc_alt_subtitle as "pc.alt.subtitle" }